import PosService from "../services/pos.service";
import GoodsService from "../services/goods.service";
import WarehouseService from "../services/wh-document.service";
import Vue from 'vue';
import { TokenService } from "../services/storage.service";
// import {TokenService} from "../services/storage.service";
// CALCULATE AND RETURN `AMOUNT_OF_PAYMENT_UZS` FOR SALE
const calculateAmountOfPaymentUzs = saleDoc => {
	let result = 0;
	for (let i = 0; i < saleDoc.saleItems.length; i++) {
		result += saleDoc.saleItems[i].priceUzs * saleDoc.saleItems[i].count;
	}
	return result;
};

// CALCULATE AND RETURN `AMOUNT_OF_AFTER_PROMO_UZS` FOR SALE
const calculateAmountOfAfterPromoUzs = saleDoc => {
	let result = 0;
	for (let i = 0; i < saleDoc.saleItems.length; i++) {
		result +=
			saleDoc.saleItems[i].discountPriceUzs * saleDoc.saleItems[i].count;
	}
	if (saleDoc.customPromotion) {
		if (saleDoc.customPromotion.discount) {
			if (parseFloat(saleDoc.customPromotion.discount) > 0) {
				if (saleDoc.customPromotion.promotionType == "%") {
					let discountPart =
						1 - parseFloat(saleDoc.customPromotion.discount) / 100;
						result = result * discountPart;
				} else if (saleDoc.customPromotion.promotionType == "PUL") {
					result =
					result -
						parseFloat(saleDoc.customPromotion.discount);
				}
			}
		}
	}
	return result;
};
// CALCULATE FINAL_TOTAL_SUM FOR SALE (AFTER CUSTOM_PROMOTION IS GIVEN TO THE SALE_DOC)
function calculateFinalTotalSum(saleDoc) {
	let returnFinalTotalSum = calculateAmountOfAfterPromoUzs(saleDoc);

	// if (saleDoc.customPromotion) {
	// 	if (saleDoc.customPromotion.discount) {
	// 		if (parseFloat(saleDoc.customPromotion.discount) > 0) {
	// 			if (saleDoc.customPromotion.promotionType == "%") {
	// 				let discountPart =
	// 					1 - parseFloat(saleDoc.customPromotion.discount) / 100;
	// 				returnFinalTotalSum = returnFinalTotalSum * discountPart;
	// 			} else if (saleDoc.customPromotion.promotionType == "PUL") {
	// 				returnFinalTotalSum =
	// 					returnFinalTotalSum -
	// 					parseFloat(saleDoc.customPromotion.discount);
	// 			}
	// 		}
	// 	}
	// }
	return returnFinalTotalSum;
}
// THIS FUNCTION IS FOR MAKING PROMOTIONS FOR EACH SALE_ITEM LOCALLY
function makeSaleItemPromotions(firstTime = true, cartItem, state) {
	let indexOfCartItem = state.cartItems.findIndex(
		item =>
			item.itemId == cartItem.itemId &&
			item._rowVariant == cartItem._rowVariant
	);
	let saleItemPromotions = [
		{
			type: "%",
			value: 0
		},
		{
			type: "PUL",
			value: 0
		}
	];

	// IF ITEM HAS CUSTOM_PROMOTION ADD IT TO SALE_ITEM_PROMOTIONS
	if (!firstTime) {
		// AT FIRS_TIME WE DON'T NEED TO CALCULATE CUSTOM_PROMOTION (CAUSE: ITEM IS JUST ADDED TO POS)
		if (cartItem.customPromotion) {
			if (cartItem.customPromotion.discount) {
				if (parseFloat(cartItem.customPromotion.discount) > 0) {
					saleItemPromotions.find(
						el => el.type == cartItem.customPromotion.promotionType
					).value += parseFloat(cartItem.customPromotion.discount);
				}
			}
		}
	}

	let itemDiscounts = [];
	if (state.currentSuspendId == null) {
		itemDiscounts = firstTime
			? cartItem.promotions
			: cartItem.currentDiscounts;
	} else {
		itemDiscounts = cartItem.currentDiscounts
			? cartItem.currentDiscounts
			: [];
	}
	if (itemDiscounts.length > 0) {
		let xForNIndex = itemDiscounts.findIndex(
			el => el.promotionType == "xForN"
		);
		if (xForNIndex > -1) {
			if (cartItem.count >= itemDiscounts[xForNIndex].count) {
				saleItemPromotions.forEach(el => {
					if (el.type == "%") {
						el.value = itemDiscounts[xForNIndex].discount;
					}
				});
			} else {
				itemDiscounts.forEach(el => {
					if (el.promotionType == "%") {
						saleItemPromotions.forEach(p => {
							if (p.type == "%") {
								p.value += el.discount;
							}
						});
					} else if (el.promotionType == "PUL") {
						saleItemPromotions.forEach(p => {
							if (p.type == "PUL") {
								p.value += el.discount;
							}
						});
					}
				});
			}
		} else {
			itemDiscounts.forEach(el => {
				if (el.promotionType == "%") {
					saleItemPromotions.forEach(p => {
						if (p.type == "%") {
							p.value += el.discount;
						}
					});
				} else if (el.promotionType == "PUL") {
					saleItemPromotions.forEach(p => {
						if (p.type == "PUL") {
							p.value += el.discount;
						}
					});
				}
			});
		}
	}

	// CHANGE DISCOUNT_PRICE_UZS OF CART_ITEM BEFORE RETURN
	if (indexOfCartItem > -1) {
		let discountSum = 0;
		saleItemPromotions.forEach(discount => {
			if (discount.type == "%" && discount.value > 0) {
				let discountPart = parseFloat(discount.value) / 100;
				discountSum +=
					discountPart * state.cartItems[indexOfCartItem].priceUzs;
			}
			if (discount.type == "PUL") {
				discountSum += discount.value;
			}
			state.cartItems[indexOfCartItem].discountPriceUzs =
				state.cartItems[indexOfCartItem].priceUzs - discountSum;
		});
	}
	return saleItemPromotions;
}
const initialState = {
	//moldova uchun yangi qo'shildi
	isOnlaynProdaja:false,
	clientName: '',
	orderNumber: null,
	clientPhoneNumber: '',
	clientAddress:'',
	///////////////

	currentSaleForCheck: {},
	currentSaleWithId: {},
	balanceItems:[],
	cartItems: [],
	lastAddedItem: null,
	totalCount: 0,
	totalSum: 0,
	currentSaleNumber: '',
	currentSaleSuspendNumber: '',
	lastSuspendedSaleNumber: '',
	currentSuspendId: null,
	currentSaleId: null,
	shopName: '',
	shopAddress: '',
	cashierFullName: '',
	currentSellerName: '',
	sellerId: null,
	shopId: null,
	discount: 0,
	errorOccur: false,
	convertError: false,
	items: [],
	searchLoading: false,
	dataIndex: 0,
	latestDrafts: [],
	latestSuspends: [],
	finishedSale: {},
	posDisabled: false,
	saleFinishError: false,
	saleFinishLoading: false,
	checkPage: false,
	saleItemForDiscountModal: {},
	customPromotion: null,
	client: {},
	finalTotalSum: 0,
	realTotalSum: 0,
	amountOfAfterPromoUzs: 0,
	amountOfPaymentUzs: 0,
	comment: '',
	isReturn: false
};

const state = () => ({...initialState});

const getters = {
	getItems: (state) => {
		let searchItems = JSON.stringify(state.items.slice());
		searchItems = JSON.parse(searchItems).map(el => {return el});
		// const lookup = searchItems.reduce((a, e) => {
		// 	a[e.id] = ++a[e.id] || 0;
		// 	return a;
		//   }, {});

		// let length = searchItems.length;
		// let equalItems = searchItems.filter(e => lookup[e.id]);
		// for (let i = 0; i < equalItems.length; i++) {
		// 	searchItems.forEach(el => {
		// 		if(el.id == equalItems[i].id) {
		// 			Vue.set(el, "isPriceDifferent", true);
		// 			if (!Array.isArray(el.incomeDates)) {
		// 				Vue.set(el, "incomeDates", el.incomeDates.substring(1, el.incomeDates.length-1).split(",").map(String));
		// 			}
		// 		}
		// 	})
		// }
		// for (let index = 0; index < length; index++) {
		// 	equalItems = searchItems.filter(el => el.itemId == searchItems[index].itemId);
		// }
		return searchItems;
	},

	getCartItems: (state) => {
		return state.cartItems
	},
	getDraft: (state) => {
		return state.latestDrafts;
	},
	getCashierName: (state) => {
		return state.cashierFullName
	},
	getDiscountItemForModal: (state) => {
		return state.saleItemForDiscountModal;
	},
	/*getCountByIndex: (state) => {
		return state.cardItems.count
	},*/
	/*permList: (state) => {
		return state.rolePermissions
	},
	response: (state) => {
		if (state.response == 'success') {
			return state.response = 'Permission qoshildi';
		}
	},
	role: (state) => {
		return (roleId) => {
			return state.roles.find(role => {
				return role.id == roleId;
			})
		};
	}*/
}


const actions = {
	/**
	 * SAVDONI FRONT ENDDA HISOB KITOBINI QILIB OXIRIDA BACK ENDGA YUBORADIGAN QILISH UCHUN
	 * QO'SHILDI BU ACTION('fetchPosSearchItems') 12.05.2020 (BAXTIYOR ADDED FROM GLOBAL_TASHKENT BRANCH)
	 */
	async fetchPosSearchItems({ commit }, keyword) {
		try {
			commit("setSearchLoader", true);
			const response = await PosService.fetchPosSearchItems(keyword);
			commit("setPosItems", response.data);
			commit("setSearchLoader", false);
			return true;
		} catch (e) {
			commit("setSearchLoader", false);
			return false;
		}
	},

	async getSaleById({commit}, saleId) {
		try {
			// sale.id = state.currentSaleId;
			const response = await PosService.getSaleWithId(saleId);
			commit('setSaleById', response.data);
			return true
		} catch (e) {
			return false
		}
	},

	async getLatestDrafts({commit}) {
		try {
			const response = await PosService.getDrafts();
			commit('setLatestDrafts', response.data)
			return true;
		} catch (e) {
			return false
		}
	},
	async getLatestSuspends({commit}) {
		try {
			const response = await PosService.getSuspends();
			commit('setLatestSuspends', response.data)
			return true;
		} catch (e) {
			return false
		}
	},
	async getActiveDiscount(){
		try {
			const response = await WarehouseService.getActiveDiscount();
			commit('setActiveDiscount', response.data)
			return true;
		} catch (e) {
			return false
		}
	},
	async createPosDraft({state, commit}, emptyObject) {
		try {
			const response = await PosService.createSaleDraftService(emptyObject, localStorage.getItem('cash_id'));
			commit('setDraft', response.data);
			commit('setErrorOccur', false);
			return response
		} catch (e) {
			await commit('setErrorOccur', true);
		}
	},

	async setErrorOccurNotHappen({commit}) {
		await commit('setErrorOccur', false);
	},

	async editDraft({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.editSaleDraft(sale);
			await commit('editDraftMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async editDraftOptom({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.editSaleDraftOptom(sale);
			await commit('editDraftOptomMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async editWholesale({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.editWholesaleService(sale);
			await commit('editDraftWholesaleMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async convertCurrency({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.currencyConvertService(sale);
			await commit('setConvertError', false);
			await commit('editDraftWholesaleMutation', response.data);
			return true
		} catch (e) {
			await commit('setConvertError', false);
			return false
		}
	},
	async suspendSale({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.suspendSaleService(sale);
			await commit('setSuspendResponse', response.data);
			return true
		} catch (e) {
			return false
		}
	},

	async editForPosDraft({commit, state}, sale) {
		try {
			const response = await PosService.editForPosDraft(sale);
			commit('editForPosDraftMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async deleteSuspendStore({commit}, itemId) {
		try {
			const response = await PosService.deleteSuspendSaleService(itemId);
			commit('deleteSuspendtMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},


	async getItemsForPos({commit}, keyword) {
		try {
			commit('setSearchLoader', true);
			const response = await GoodsService.fetchGoodsForPos(keyword);
			commit('setPosItems', response.data);
			commit('setSearchLoader', false);
			return true
		} catch (e) {
			commit('setSearchLoader', false);
			return false
		}
	},
	async getItemsForPosReturn({commit}, keyword) {
		try {
			commit('setSearchLoader', true);
			const response = await GoodsService.fetchGoodsForPos(keyword);
			commit('setPosItems', response.data);
			commit('setSearchLoader', false);
			return true
		} catch (e) {
			commit('setSearchLoader', false);
			return false
		}
	},

	async saleFinish({state, commit, dispatch}, payload) {
		try {
			commit('setSaleFinishLoading', true);
			if (state.currentSuspendId != null) {
				payload.id = state.currentSuspendId;
			} else {
				payload.id = state.currentSaleId;
			}
			const response = await PosService.finishSale(payload);
			await commit('setFinishedSale', response.data);
			commit('setSaleFinishLoading', false);
			// await commit('resetState');
			await commit('clients/resetCurrentClient', null, {root: true});
			await commit('clients/setMemberCardForSideBar', {}, {root: true});
			// await dispatch('createPosDraft', {});
			await dispatch('getLatestSuspends');
			return true
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setSaleFinishError', {message: response.message, boolean: true});
			commit('setSaleFinishLoading', false);
			return false;
		}
	},

	async increaseCount({commit}, dataIndex) {
		await commit('increaseCountWithIndex', dataIndex);
		// commit('setPosToStorage');
	},
	async decreaseCount({commit}, dataIndex) {
		await commit('decreaseCountWithIndex', dataIndex);
		// commit('setPosToStorage');
	},
	setSusPendClient({commit}, client) {
		commit('setClientSuspend', client);
	},

	setSaleItemForDiscountModal({commit}, data) {
		commit('setSaleItemForDiscountModalMutation', data);
	},
	async setIncrementValue({commit}, payload) {
		await commit('setValue', payload);
	},

	async addToCartAction({commit}, item) {
		await commit('setCartItem', item);
		// commit('setPosToStorage');
	},
	async clearCartItems ({commit})  {
		await commit('clearCartItems');
	},
	async deleteFromCartAction({commit}, index) {
		await commit('deleteItemFromCart', index);
	},
	/*getPosFromStorage({commit}, posObj) {
		commit('setPosObjToState', posObj);
	}*/
};

const mutations = {

	// moldova uchun yangi
	clearOnlaynProdaja(state) {
		state.orderNumber=null
		state.clientName=''
		state.clientPhoneNumber=''
		state.clientAddress=''
		state.isOnlaynProdaja=false
	},
	setIsOnlaynProdaja(state, value) {
		state.isOnlaynProdaja = value
	},
	setAddressDelivery(state, value) {
		state.clientAddress = value
	},
	setOrderNumber(state, value) {
		state.orderNumber  = value
	},
	setClient(state, value) {
		state.clientName = value
	},
	setContactNumber(state, value) {
		state.clientPhoneNumber  = value
	},
	/**
	 * SAVDONI FRONT ENDDA HISOB KITOBINI QILIB OXIRIDA BACK ENDGA YUBORADIGAN QILISH UCHUN
	 * QO'SHILDI BU MUTATION('editPosSaleLocally') 12.05.2020 (BAXTIYOR ADDED FROM GLOBAL_TASHKENT BRANCH)
	 */
	async editPosSaleLocally(state, {saleDoc, fromDelete = false}) {
		state.cashierFullName = saleDoc.cashierFullName;
		/** IF ITEM IS NEW ADDED SET saleItemId TO IT **/
		if (state.lastAddedItem && !fromDelete) {
			// SAVE SEARCHITEM PROMOTIONS TO OTHER VARIABLE ON SALEITEM
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"currentDiscounts",
				saleDoc.saleItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				).promotions
			);

			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"saleItemId",
				saleDoc.saleItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				).saleItemId
			);
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"discountPriceUzs",
				saleDoc.saleItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				).priceUzs
			);
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"promotions",
				makeSaleItemPromotions(
					// {firstTime, cartItem, state}
					true,
					state.cartItems.find(
						el =>
							el.itemId == state.lastAddedItem.itemId &&
							el._rowVariant == state.lastAddedItem._rowVariant
					),
					state
				)
			);
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"customPromotion",
				{}
			);
			state.cartItems.find(
				el =>
					el.itemId == state.lastAddedItem.itemId &&
					el._rowVariant == state.lastAddedItem._rowVariant
			).id = saleDoc.saleItems.find(
				el =>
					el.itemId == state.lastAddedItem.itemId &&
					el._rowVariant == state.lastAddedItem._rowVariant
			).saleItemId;
		} // LASTADDEDITEM IF END

		if (saleDoc.saleItems.length > state.cartItems.length) {
			saleDoc.saleItems.forEach(el => {
				if (el.qty > 0 && el.qty >= el.count) {
					let foundIndex = state.cartItems.findIndex(
						item =>
							item.itemId == el.itemId &&
							item._rowVariant == el._rowVariant
					);
					if (foundIndex < 0) {
						state.cartItems.push(el);
					}
				} else {
					let foundIndex = state.balanceItems.findIndex(
						item =>
							item.itemId == el.itemId &&
							item._rowVariant == el._rowVariant
					);
					if (foundIndex < 0) {
						state.balanceItems.push(el);
						state.cartItems.forEach(cart => {
							if (cart._rowVariant == "warning") {
								state.balanceItems.forEach(item => {
									if (
										cart.itemId == item.itemId &&
										cart._rowVariant == item._rowVariant
									) {
										item.qty = cart.qty - cart.count;
									}
								});
							}
						});
					}
				}
			});
		}
		if (saleDoc.saleItems.length < state.cartItems.length) {
			let tempForLoop = state.cartItems.length;
			for (let i = tempForLoop; i > 0; i--) {
				let el = state.cartItems[i - 1];
				let foundIndex = saleDoc.saleItems.findIndex(
					item =>
						item.itemId == el.itemId &&
						item._rowVariant == el._rowVariant
				);
				if (foundIndex < 0) {
					state.cartItems.splice(state.cartItems.indexOf(el), 1);
					state.balanceItems.splice(
						state.balanceItems.indexOf(el),
						1
					);
				}
			}
		}
		saleDoc.saleItems.forEach(el => {
			if (el.qty > el.count) {
				state.balanceItems.forEach(item => {
					if (item.itemId == el.itemId) {
						state.balanceItems.splice(
							state.balanceItems.indexOf(el),
							1
						);
					}
				});
			}
			if (el.qty > 0) {
				if (el.customPromotion) {
					if (
						state.cartItems.find(
							item =>
								item.itemId == el.itemId &&
								item._rowVariant == el._rowVariant
						)
					) {
						Vue.set(
							state.cartItems.find(
								item =>
									item.itemId == el.itemId &&
									item._rowVariant == el._rowVariant
							),
							"customPromotion",
							saleDoc.saleItems.find(
								item =>
									item.itemId == el.itemId &&
									item._rowVariant == el._rowVariant
							).customPromotion
						);
						Vue.set(
							state.cartItems.find(
								item =>
									item.itemId == el.itemId &&
									item._rowVariant == el._rowVariant
							),
							"discountPriceUzs",
							saleDoc.saleItems.find(
								item =>
									item.itemId == el.itemId &&
									item._rowVariant == el._rowVariant
							).discountPriceUzs
						);
						Vue.set(
							state.cartItems.find(
								item =>
									item.itemId == el.itemId &&
									item._rowVariant == el._rowVariant
							),
							"promotions",
							makeSaleItemPromotions(
								// {firstTime, cartItem, state}
								false,
								state.cartItems.find(
									item =>
										item.itemId == el.itemId &&
										item._rowVariant == el._rowVariant
								),
								state
							)
						);
					}
				}
				if (el.qty > 0 && el.qty >= el.count) {
					Vue.set(
						state.cartItems.find(
							item =>
								item.itemId == el.itemId &&
								item._rowVariant == el._rowVariant
						),
						"count",
						saleDoc.saleItems.find(
							item =>
								item.itemId == el.itemId &&
								item._rowVariant == el._rowVariant
						).count
					);
				}
			}
		});
		state.finalTotalSum = calculateFinalTotalSum(saleDoc);
		state.realTotalSum = saleDoc.realTotalSum;
		state.amountOfPaymentUzs = calculateAmountOfPaymentUzs(saleDoc);
		state.amountOfAfterPromoUzs = calculateAmountOfAfterPromoUzs(saleDoc);
	},
	setCurrentSaleForCheck(state, currentDoc) {
		state.currentSaleForCheck = currentDoc;
	},
	setSaleById(state, response) {
		state.currentSaleWithId = response;
	},

	resetState(state) {
		state.cartItems = [];
		state.totalCount = initialState.totalCount;
		state.totalSum = initialState.totalSum;
		state.customPromotion = initialState.customPromotion;
		state.discount = initialState.discount;
		state.finalTotalSum = initialState.finalTotalSum;
		state.realTotalSum = initialState.realTotalSum;
		state.amountOfPaymentUzs = initialState.amountOfPaymentUzs;
		state.amountOfAfterPromoUzs = initialState.amountOfAfterPromoUzs;
		state.comment = initialState.comment;

	},
	setPosDisabled(state, boolean) {
		state.posDisabled = boolean;
	},
	setErrorOccur(state, payload) {
		state.errorOccur = payload
	},
	setConvertError(state, payload) {
		state.convertError = payload
	},
	setMemberCardForDiscount(state, memberCardDiscount) {
		state.discount = memberCardDiscount;
	},
	setClientSuspend(state, client) {
		state.client = client;
	},
	resetSuspendId(state) {
		state.currentSuspendId = null
	},
	setSellerName(state, stringForName) {
		state.currentSellerName = stringForName;
	},
	setSellerId(state, sellerId) {
		state.sellerId = sellerId;
	},
	setSaleItemForDiscountModalMutation(state, data) {
		state.saleItemForDiscountModal = data;
	},
	setCustomPromotionForItem(state, payload) {
		Vue.set(state.cartItems[payload.index], "customPromotion", payload.obj);
		state.lastAddedItem = null;
	},
	setCustomPromotionGeneral(state, payload) {
		state.customPromotion = payload.obj;
	},

	deleteSuspendtMutation(state, response) {

	},

	setLatestDrafts(state, response) {
		state.latestDrafts = response;
	},
	setLatestSuspends(state, response) {
		state.latestSuspends = response;
	},
	editDraftWholesaleMutation(state, response) {
		state.cashierFullName = response.cashierFullName;
		// state.cartItems = response.saleItems ? response.saleItems : [];
		// state.cartItems.customPromotion = null;
		response.saleItems.forEach(el => {
			if (el.customPromotion) {
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "customPromotion", response.saleItems.find(item => item.itemId == el.itemId).customPromotion)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "discountPriceUzs", response.saleItems.find(item => item.itemId == el.itemId).discountPriceUzs)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "priceUzs", response.saleItems.find(item => item.itemId == el.itemId).priceUzs)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "promotions", response.saleItems.find(item => item.itemId == el.itemId).promotions)
			}
		});

		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		if (response.customPromotion.discount >= 0) {
			state.discount = response.customPromotion.discount;
		} else {
			state.discount = 0;
		}
	},
	editDraftOptomMutation(state, response) {
		state.cashierFullName = response.cashierFullName;
		state.cartItems = response.saleItems ? response.saleItems : [];
		// state.cartItems.customPromotion = null;
		response.saleItems.forEach(el => {
			if (el.customPromotion) {
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "customPromotion", response.saleItems.find(item => item.itemId == el.itemId).customPromotion)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "discountPriceUzs", response.saleItems.find(item => item.itemId == el.itemId).discountPriceUzs)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "promotions", response.saleItems.find(item => item.itemId == el.itemId).promotions)
			}
		});

		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		if (response.customPromotion.discount >= 0) {
			state.discount = response.customPromotion.discount;
		} else {
			state.discount = 0;
		}
	},
	editDraftMutation(state, response) {
		state.cashierFullName = response.cashierFullName;
		/** IF ITEM IS NEW ADDED SET saleItemId TO IT **/
		if (state.lastAddedItem) {
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "saleItemId", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).saleItemId);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "promotions", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).promotions);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "discountPriceUzs", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).discountPriceUzs);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "customPromotion", null);
			state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).id = response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).saleItemId;
		}
		if (response.saleItems.length > state.cartItems.length) {
			response.saleItems.forEach(el => {
				if(el.qty > 0 && el.qty >= el.count) {
					let foundIndex = state.cartItems.findIndex(item => item.itemId == el.itemId  && item._rowVariant == el._rowVariant)
					if (foundIndex < 0) {
						state.cartItems.push(el);
					}
				}else {
					let foundIndex = state.balanceItems.findIndex(item => item.itemId == el.itemId  && item._rowVariant == el._rowVariant)
						if (foundIndex < 0 ) {
							state.balanceItems.push(el);
							state.cartItems.forEach(cart => {
								if(cart._rowVariant == 'warning') {
									state.balanceItems.forEach(item => {
										if(cart.itemId == item.itemId && cart._rowVariant == item._rowVariant) {
											item.qty = cart.qty - cart.count
										}
									})
								}
							})
						}
				}})}
		if(response.saleItems.length < state.cartItems.length) {
			let tempForLoop = state.cartItems.length;
			for(let i=tempForLoop; i>0; i--) {
			  let el = state.cartItems[i-1];
			  let foundIndex = response.saleItems.findIndex(item => item.itemId == el.itemId  && item._rowVariant == el._rowVariant)
			  if (foundIndex < 0) {
				  state.cartItems.splice(state.cartItems.indexOf(el), 1)
				  state.balanceItems.splice(state.balanceItems.indexOf(el), 1)
			  }
			 }
		}
		response.saleItems.forEach(el => {
			if(el.qty > el.count) {
				state.balanceItems.forEach(item => {
					if(item.itemId == el.itemId) {
						state.balanceItems.splice(state.balanceItems.indexOf(el), 1)
					}
				})
			}
			if(el.qty> 0) {
				if (el.customPromotion ) {
					if(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant)) {
						Vue.set(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant), "customPromotion", response.saleItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant).customPromotion)
						Vue.set(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant), "discountPriceUzs", response.saleItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant).discountPriceUzs)
						Vue.set(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant), "promotions", response.saleItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant).promotions)
					}

				}
				if(el.qty> 0 && el.qty >= el.count) {
					Vue.set(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant ), "count", response.saleItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant).count)
				}}
		});
		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		if (response.customPromotion.discount >= 0) {
			state.discount = response.customPromotion.discount;
		} else {
			state.discount = 0;
		}
	},
	setSuspendResponse(state, response) {
		state.lastSuspendedSaleNumber = response.saleNumber;
	},

	editForPosDraftMutation(state, response) {
		state.cartItems = response.saleItems ? response.saleItems : [];
		for (let i = 0; i < response.saleItems.length; i++) {
			state.totalCount += response.saleItems[i].count;
		}
		state.totalSum = response.amountOfPaymentUzs;
		state.currentSaleSuspendNumber = response.saleNumber;
		state.currentSuspendId = response.id;
		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		state.amountOfPaymentUzs = response.amountOfPaymentUzs;
		state.amountOfAfterPromoUzs = response.amountOfAfterPromoUzs;
		state.comment = response.comment;
		if (response.customPromotion != undefined) {
			state.customPromotion = response.customPromotion;
		} else {
			state.customPromotion = null;
		}
		// state.totalCount = response.saleItems[0].count;

	},
	setFinishedSale(state, response) {
		state.finishedSale = response;
		state.saleFinishError = false;
		state.currentSuspendId = null;
	},
	setSaleFinishError(state, obj) {
		state.saleFinishError = obj.message;
		state.finishedSale = {};
	},
	setSaleFinishLoading(state, boolean) {
		state.saleFinishLoading = boolean;
	},
	/*setPosToStorage(state) {
		let temp = {
			cartItems: state.cartItems,
			totalCount: state.totalCount,
			totalSum: state.totalSum
		}
		TokenService.setPos(JSON.stringify(temp));
	},*/

	setDraft(state, response) {
		state.currentSaleNumber = response.saleNumber;
		state.currentSaleId = response.id;
		state.shopName = response.shopName;
		state.shopAddress = response.shopAddress;
		state.shopId = response.shopId;
		state.cashierFullName = response.cashierFullName;
		//state.discount = response.customPromotion.discount;
	},
	setSearchLoader(state, boolean) {
		state.searchLoading = boolean;
	},
	setPosItems(state, items) {
		state.items = items;
	},
	increaseCountWithIndex(state, dataIndex) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA IF GA KIRADI **/
		if (state.cartItems[dataIndex]._rowVariant) {
			state.cartItems[dataIndex].count -= 1;
			state.totalSum -= state.cartItems[dataIndex].priceUzs;
		} else {
			state.cartItems[dataIndex].count += 1;
			state.totalSum += state.cartItems[dataIndex].priceUzs;
		}
		state.lastAddedItem = null;
		state.totalCount++;

	},
	decreaseCountWithIndex(state, dataIndex) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA IF GA KIRADI **/
		if (state.cartItems[dataIndex]._rowVariant && state.cartItems[dataIndex].count < -1) {
			state.cartItems[dataIndex].count += 1;
			state.totalSum += state.cartItems[dataIndex].priceUzs;
			state.totalCount--;
		} else if (state.cartItems[dataIndex].count > 1) {
			state.cartItems[dataIndex].count -= 1
			state.totalSum -= state.cartItems[dataIndex].priceUzs;
			state.totalCount--;
		}
		state.lastAddedItem = null;
	},
	/** BU CODENI DRAFTNI QAYTA SET QILISHDA ISHLATSA BO'LADI **/
	/*setPosObjToState(state, posObj) {
		if (posObj) {
			state.cartItems = posObj.cartItems;
			state.totalCount = posObj.totalCount;
			state.totalSum = posObj.totalSum;
		}
	},*/
	deleteItemFromCart(state, index) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA IF GA KIRADI **/
		if (state.cartItems[index]._rowVariant) {
			state.totalCount += state.cartItems[index].count;
			state.totalSum += state.cartItems[index].priceUzs * state.cartItems[index].count;
		} else {
			state.totalCount -= state.cartItems[index].count;
			state.totalSum -= state.cartItems[index].priceUzs * state.cartItems[index].count;
		}
		state.cartItems.splice(index, 1);
		if (state.cartItems.length == 0) {
			state.finalTotalSum = 0;
		}
	},

	setValue(state, payload) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA BIRINCHI IF GA KIRADI **/
		if (state.cartItems[payload.index]._rowVariant) {
			state.totalCount += state.cartItems[payload.index].count;
			state.totalCount += payload.newCount;
			state.totalSum += state.cartItems[payload.index].count * state.cartItems[payload.index].priceUzs;
			state.totalSum += payload.newCount * state.cartItems[payload.index].priceUzs;
			state.cartItems[payload.index].count = -payload.newCount;
		} else {
			state.totalCount -= state.cartItems[payload.index].count;
			state.totalCount += payload.newCount;
			state.totalSum -= state.cartItems[payload.index].count * state.cartItems[payload.index].priceUzs;
			state.totalSum += payload.newCount * state.cartItems[payload.index].priceUzs;
			state.cartItems[payload.index].count = payload.newCount;
		}
		state.lastAddedItem = null;
	},
	setCartItem(state, cartItem) {
		state.totalCount++;
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA BIRINCHI IF GA KIRADI **/
		if (state.isReturn) {
			state.totalSum -= cartItem.priceUzs;
			let foundIndex = (state.cartItems.findIndex(el => {
				return el.itemId == cartItem.itemId && el.termOfItem == cartItem.termOfItem && el._rowVariant == 'danger' && el.priceUzs == cartItem.priceUzs;
			}));
			if (foundIndex > -1 && state.cartItems[foundIndex]._rowVariant) {
				state.lastAddedItem = null;
				state.cartItems[foundIndex].count -= 1
			} else {
				Vue.set(cartItem, "count", -1);
				Vue.set(cartItem, "_rowVariant", 'danger');
				state.cartItems.push(cartItem);
				state.lastAddedItem = cartItem;
			}
		} else {
			let foundIndex = (state.cartItems.findIndex(el => {
				return el.itemId == cartItem.itemId && el.termOfItem == cartItem.termOfItem && el.priceUzs == cartItem.priceUzs;
			}));
			state.totalSum += cartItem.priceUzs;
			if (foundIndex > -1 && !state.cartItems[foundIndex]._rowVariant) {
				state.lastAddedItem = null;
				state.cartItems[foundIndex].count += 1
			} else {
				Vue.set(cartItem, "count", 1);
				state.cartItems.unshift(cartItem);
				state.lastAddedItem = cartItem;
			}
		}
	},
	clearCartItems(state){
		state.cartItems = []
	},
	/** BU VOZVRAT UCHUN **/
	setIsReturn(state, boolean) {
		state.isReturn = boolean;
	}

};

export const pos = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
